import { decodeJwt } from '../secrets/decodeJwt'

/**
 * Fetches data from the specified URL, decodes the response using a JWT decoder, 
 * and returns the decoded data.
 *
 * @param {string} url - The URL to fetch data from.
 * @param {RequestInit} options - The options to pass to the fetch request.
 * @returns {Promise<any>} - A promise that resolves to the decoded data.
 *
 * @throws {Error} If the fetch request fails or the response cannot be decoded.
 */
export const fetchCommissionsDecoded = async (url, options) => {
  const response = await fetch(url, options)
  const data = await response.text()
  return decodeJwt(process.env.REACT_APP_KEY_COMMISSIONS_H512)(data)
}
